<template>
    <app-layout>
      <Head title="Custom Fields"/>
      <template #header>
        <div class="flex justify-between">
          <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Create a new Custom Field
          </h2>
        </div>
      </template>
  
      <div class="max-w-7xl mx-auto flex mb-6">
        <div class="w-full sm:px-6 lg:px-8">
          <div class="bg-white shadow-xl sm:rounded-lg sm:p-6 lg:p-8">
            <jet-form-section @submitted="submitHandler">
                <template #description>
                    <span class="text-base text-gray-800">
                        <span class="block mb-3 ">
                            <span class='font-bold'>Custom fields</span> help you track specific information about your contacts beyond basic details.
                        </span>
                        
                        <span class="block mb-2 font-medium ">Available field types:</span>
                        <span class="block ml-4 mb-3 ">
                            <span class="block mb-2">
                                <span class="font-bold ">Text:</span> For names, notes, or any free-form text
                            </span>
                            <span class="block mb-2">
                                <span class="font-bold ">Number:</span> For quantities, amounts, or numeric values
                            </span>
                            <span class="block mb-2">
                                <span class="font-bold ">Date:</span> For birthdays, anniversaries, or deadlines
                            </span>
                            <span class="block mb-2">
                                <span class="font-bold ">URL:</span> For website links, these are automatically shortened with the TextSpot link shortner and link clicks tracked per contact.
                            </span>
                            <span class="block">
                                <span class="font-bold ">Address:</span> For physical locations with proper formatting
                            </span>
                        </span>
                        
                        <span class="block ">
                            Choose a field type that matches your data. Each custom field you create will be available for all contacts.<br /><br />

                            You can set Custom Field data by using the Contact Upload feature with a spreadsheet.
                        </span>
                    </span>
                </template>

                <template #form>
                        
                        <div class="col-span-12">
                            <label class="flex flex-col">
                                <div>
                                    Custom Field Name<span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 block w-full"
                                    v-model="form.name"
                                />
                            </label>
                            <jet-input-error :message="form.errors.name" class="mt-2" />
                        </div>

                        <div class="col-span-12">
                            <label class="flex flex-col">
                                <div>Field Type <span class="required">*</span></div>
                            </label>
                            <multiselect
                                :options="fieldTypeOptions"
                                placeholder="Select a field type"
                                v-model="fieldTypeObject"
                                label="label"
                                select-label=""
                                deselect-label=""
                                :closeOnSelect="true"
                                :clearOnSelect="false"
                            />
                            <jet-input-error :message="form.errors.field_type" class="mt-2" />
                            <label class="flex items-center cursor-pointer mt-2" v-if="fieldType == 'Number'">
                                <input
                                    type="checkbox"
                                    class="form-checkbox"
                                    v-model="form.show_decimal"
                                />
                                <span class="ml-2 text text-gray-800">
                                    Show decimal places
                                </span>
                            </label>
                        </div>


                    </template>
                    <template #actions>
                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                        >
                            Submit
                        </jet-button>
                    </template>
                </jet-form-section>
                
          </div>
        </div>
      </div>
    </app-layout>
  </template>
  
  <script>

  export default {
    mounted() {
    },
    components: {
    },
    props: {
    },
    data() {
      return {
        fieldTypeObject: null,
        form: this.$inertia.form(
          {
            field_type: null,
            name: null,
            show_decimal: false,
          },
          {
            bag: "createCustomField",
            resetOnSuccess: true
          }
        ),

      };
    },
    computed: {
        fieldTypeOptions() {
            return this.$page.props.custom_field_types.data.map((fieldType) => {
                return {
                    label: fieldType.name,
                    value: fieldType.tra_id
                };
            });
        },
        fieldType() {
            if (!this.fieldTypeObject) {
                return null;
            }
            return this.fieldTypeObject.label;
        }
    },
    watch: {
        fieldType() {
            this.form.field_type = this.fieldType;
        }
    },
    methods: {
      submitHandler() {
        this.form.post(
          route("custom-fields.store", {
            preserveScroll: true
          })
        );
      }, //ends submitHandler
    }
  };
  </script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
